
import Home from '../main/home';

import ServicesHallView from '../main/hall-services';
import DemandHallView from '../main/hall-demand';
import CompanyHallView from '../main/hall-company';
import ServiceDetailsView from '../main/hall-services/details'
import ServiceOrderView from '../main/hall-services/order'
import DemandDetailsView from '../main/hall-demand/details'
import CpyDetailsView from '../main/cpydetails'

// 配置路由
export const router = [
    {
        label: '首页',
        key: '/',
        mode: <Home />
    },
    {
        label: '服务大厅',
        key: '/serviceshall',
        mode: <ServicesHallView />
    },
    {
        label: '服务详情',
        key: '/serviceshall/details/:id',
        mode: <ServiceDetailsView />
    },
    {
        label: '服务下单',
        key: '/serviceshall/order/:id',
        mode: <ServiceOrderView />
    },
    {
        label: '需求大厅',
        key: '/demandhall',
        mode: <DemandHallView />
    },
    {
        label: '需求详情',
        key: '/demandhall/details/:id',
        mode: <DemandDetailsView />
    },
    {
        label: '企业详情',
        key: '/cpydetails/:id',
        mode: <CpyDetailsView />
    },
    {
        label: '组织名录',
        key: '/companyhall',
        mode: <CompanyHallView />
    },
]

// 配置菜单导航
export const menu = [
    {
        label: '首页',
        key: '/',
    },
    {
        label: '服务大厅',
        key: '/serviceshall',
    },
    {
        label: '需求大厅',
        key: '/demandhall',
    },
    {
        label: '组织名录',
        key: '/companyhall',
    },
]
